import React, { useMemo, useState } from "react";

import Button from "@cayuse/shared-react.components.button";
import ExtraSettingsTabs from "containers/Form/SimplifiedBuilder/Components/ExtraSettings";
import { useDictionary } from "hooks";

import styles from "./styles.css";

const PanelHeaderComponent = ({ completeFormModel, config, onChange }) => {
	const dictionary = useDictionary("simplifiedBuilder.section.header");
	const [ showMoreSettings, setShowMoreSettings ] = useState(false);

	const title = useMemo(() => {
		const sectionName = config.label;
		const sectionIndex = completeFormModel?.extraSettings?.sections?.findIndex(section => {
			return section.label === sectionName;
		});

		return `Form Section - ${sectionIndex + 1}. ${sectionName}`;
	}, [ completeFormModel, config.label ]);

	return (
		<div className={`ui segment ${styles.segment}`}>
			<div className={styles.header}>
				<div className={`ui input`}>
					<h2 id="region-heading"><strong>{title}</strong></h2>
				</div>
				<div className="ui input">
					<Button
						onClick={() => setShowMoreSettings(!showMoreSettings)}
						secondary
						aria-controls={`extra-settings-${config.id}`}
						aria-expanded={String(showMoreSettings)}
					>
						{showMoreSettings ? dictionary.hideSettings : dictionary.showSettings}
					</Button>
				</div>
			</div>
			{showMoreSettings && (
				<div>
					<hr className={styles.dividingLine}/>
					<div
						aria-labelledby="region-heading"
						id={`extra-settings-${config.id}`}
						className={styles.toolbar}
						role="region"
					>
						<ExtraSettingsTabs
							parentQuestionConfig={config}
							completeFormModel={completeFormModel}
							onChangeConfig={onChange}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default PanelHeaderComponent;
